// @flow
import * as React from 'react';
import { Box, Button, Stack, SxProps, Typography } from '@mui/material';
import {
  Timeline,
  TimelineConnector,
  TimelineContent,
  TimelineDot,
  TimelineItem,
  TimelineOppositeContent,
  TimelineSeparator
} from '@mui/lab';
import moment from 'moment';
import { useEnrollments } from './hooks/use-enrollments';
import { Preloader } from '@coverright/features';
import { MaEnrollment } from './ui/ma-enrollment';
import { useClient } from '../../hooks/client-context';
import { PdpEnrollment } from './ui/pdp-enrollment';
import { MgEnrollment } from './ui/mg-enrollment';
import { CreateEnrollmentButton } from './ui/create-enrollment-button';
import { EnrollmentType } from '@coverright/data-access/types/enrollment';


export const Enrollments = () => {
  const client = useClient();
  const {loading, enrollments, refetch} = useEnrollments(client)

  if (loading) {
    return <Preloader sx={{height: 500}} />;
  }

  const today = moment().format('L')

  const hasEnrollmentsToday = Object.keys(enrollments).includes(today)

  return (
    <Stack gap={3}>
      <Typography variant={'subtitle1'} flex={1}>Enrollments</Typography>

      <Timeline sx={styles}>
        {!hasEnrollmentsToday && <TimelineItem>
          <TimelineOppositeContent>
            <Typography variant={'body2'} color={'text.secondary'}>
              {today}
            </Typography>
          </TimelineOppositeContent>
          <TimelineSeparator>
            <TimelineDot variant="outlined" />
            <TimelineConnector />
          </TimelineSeparator>
          <TimelineContent>
            <CreateEnrollmentButton onSubmit={() => refetch()}>
              Create enrollment
            </CreateEnrollmentButton>
          </TimelineContent>
        </TimelineItem>}

        {Object.keys(enrollments).length > 0 && (
          Object.keys(enrollments).map((date) => (
            <TimelineItem key={date}>
              <TimelineOppositeContent>
                <Typography variant={'body2'} color={'text.secondary'}>{date}</Typography>
              </TimelineOppositeContent>
              <TimelineSeparator>
                <TimelineDot variant="outlined" />
                <TimelineConnector />
              </TimelineSeparator>
              <TimelineContent>
                <Stack gap={1.5} direction={'row'} flexWrap={'wrap'}>
                  {enrollments[date].map((enrollment) => (
                    <React.Fragment key={enrollment.id}>
                      {enrollment.type === EnrollmentType.Ma && (
                        <MaEnrollment enrollment={enrollment} onChange={refetch} />
                      )}
                      {enrollment.type === EnrollmentType.Pdp && (
                        <PdpEnrollment enrollment={enrollment} onChange={refetch} />
                      )}
                      {enrollment.type === EnrollmentType.Mg && (
                        <MgEnrollment enrollment={enrollment} onChange={refetch} />
                      )}
                    </React.Fragment>
                  ))}
                  {hasEnrollmentsToday && date === today && (
                    <CreateEnrollmentButton onSubmit={() => refetch()}>
                      Add enrollment
                    </CreateEnrollmentButton>
                  )}
                </Stack>
              </TimelineContent>
            </TimelineItem>
          ))
        )}
      </Timeline>
    </Stack>
  );
};

const styles: SxProps = {
  '& .MuiTimelineOppositeContent-root': {
    flex: 'initial',
    minWidth: 112,
  },
  px: 0,
  mt: 0
}
